export default __webpack_public_path__ + "static/media/veronica-adams@2x.76605940.jpg";